module.exports = __webpack_public_path__ + "static/img/pic-cangku-default.feb639dd.png";